import { Box, Typography } from '@material-ui/core';
import AppDialog from 'components/basic/AppDialog';
import { TraitsCtx } from 'pages/TraitsPage';
import React, { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';
import { TraitService } from 'services';
import { getTheme } from 'theme';
// import { useHistory, useLocation } from 'react-router';

function DeleteTraitDialog() {
  const { delTraitDialog, closedelTraitDialog } = useContext(TraitsCtx);
  const queryClient = useQueryClient();
  // const history = useHistory();
  // const location = useLocation();

  const deleteMutation = useMutation((trait) => {
    return TraitService.delete(trait);
  }, {
    onSuccess: () => {
      return queryClient.invalidateQueries('trait')
        .then(() => {
          closedelTraitDialog();
        });
    },
  });
  return (
    <AppDialog
      title='Delete Trait?'
      open={ delTraitDialog.open }
      onClose={ () => {
        return closedelTraitDialog();
      } }
      onSubmit={ () => {
        return deleteMutation.mutate(delTraitDialog.payload);
      } }
      loading={ deleteMutation.isLoading }
    >
      <Box style={ { padding: getTheme().spacing(2), maxWidth: 300 } }>
        <Typography>Are you sure you want to delete this Trait?</Typography>
      </Box>
    </AppDialog>
  );
}

export default DeleteTraitDialog;
